export var PartialRealisationAllocationLogic;
(function (PartialRealisationAllocationLogic) {
    PartialRealisationAllocationLogic["ProRata"] = "proRata";
    PartialRealisationAllocationLogic["FIFO"] = "fifo";
    PartialRealisationAllocationLogic["LIFO"] = "lifo";
    PartialRealisationAllocationLogic["Manual"] = "manual";
})(PartialRealisationAllocationLogic || (PartialRealisationAllocationLogic = {}));
export var ConsiderationType;
(function (ConsiderationType) {
    ConsiderationType["CashAndWithholdingTax"] = "cashAndWithholdingTax";
    ConsiderationType["Equity"] = "equity";
})(ConsiderationType || (ConsiderationType = {}));
export var ConsiderationAllocationLogic;
(function (ConsiderationAllocationLogic) {
    ConsiderationAllocationLogic["ProRata"] = "proRata";
    ConsiderationAllocationLogic["Manual"] = "manual";
})(ConsiderationAllocationLogic || (ConsiderationAllocationLogic = {}));
export var RealisationTypes;
(function (RealisationTypes) {
    RealisationTypes["RealisationCreated"] = "realisationCreated";
})(RealisationTypes || (RealisationTypes = {}));
export var RealisationTransactionSubType;
(function (RealisationTransactionSubType) {
    RealisationTransactionSubType["CashProceeds"] = "cashProceeds";
    RealisationTransactionSubType["EscrowProceeds"] = "escrowProceeds";
    RealisationTransactionSubType["SaleOfInvestment"] = "saleOfInvestment";
    RealisationTransactionSubType["RealisedGain"] = "realisedGain";
    RealisationTransactionSubType["RealisedGainFX"] = "realisedGainFX";
    RealisationTransactionSubType["RealisedLoss"] = "realisedLoss";
    RealisationTransactionSubType["RealisedLossFX"] = "realisedLossFX";
    RealisationTransactionSubType["WithholdingTax"] = "withholdingTax";
    RealisationTransactionSubType["UnrealisedGainsUnwind"] = "unrealisedGainsUnwind";
    RealisationTransactionSubType["UnrealisedLossesUnwind"] = "unrealisedLossesUnwind";
})(RealisationTransactionSubType || (RealisationTransactionSubType = {}));
export var ConsiderationTypeHoldingClassTypes;
(function (ConsiderationTypeHoldingClassTypes) {
    ConsiderationTypeHoldingClassTypes["LcyHoldingClass"] = "LcyHoldingClass";
    ConsiderationTypeHoldingClassTypes["NonLcyConsiderationNonLcyHoldingClass"] = "NonLcyConsiderationNonLcyHoldingClass";
    ConsiderationTypeHoldingClassTypes["LcyConsiderationForNonLcyHoldingClass"] = "LcyConsiderationForNonLcyHoldingClass";
    ConsiderationTypeHoldingClassTypes["ThreeCYNonLcyConsiderationNonLcyHoldingClass"] = "ThreeCYNonLcyConsiderationNonLcyHoldingClass";
})(ConsiderationTypeHoldingClassTypes || (ConsiderationTypeHoldingClassTypes = {}));
//# sourceMappingURL=index.js.map